import type { CustomerInvoicePresentation } from "../../read-models/billing/customer-invoice-read-model";

/** Explicit allowlist shared by the Pages BFF and browser composition. */
export const invoicePresentation = (input: unknown): CustomerInvoicePresentation => {
  if (typeof input !== "object" || input === null || Array.isArray(input)) return {};
  const row = input as Record<string, unknown>;
  const result: Record<string, unknown> = {};
  if(["INITIAL_50","CLOSING_50"].includes(String(row.billingPhase))) result.billingPhase=row.billingPhase;
  for (const key of ["serviceId", "serviceName", "description", "planName", "contractId", "contractCode", "subscriptionId"]) {
    if (typeof row[key] === "string" && row[key].length <= 4000) result[key] = ["planName","serviceName","description"].includes(key)?row[key].replace(/\bcommon\.packageTier\.([A-Z0-9_-]+)\b/gu,"$1"):row[key];
  }
  for (const key of ["competence", "periodStart", "periodEnd"]) {
    if (typeof row[key] === "string" && Number.isFinite(Date.parse(row[key]))) result[key] = row[key];
  }
  for (const key of ["subtotal", "additions", "amountPaid"]) {
    if (typeof row[key] === "string" && /^-?\d+(?:\.\d+)?$/u.test(row[key])) result[key] = row[key];
  }
  const safeUrl = (value: unknown, host: string): string | undefined => {
    try { if(typeof value !== "string") return undefined; const url = new URL(value);
      return url.protocol === "https:" && url.hostname === host && !url.username && !url.password ? url.href : undefined;
    } catch { return undefined; }
  };
  const logo = safeUrl(row.serviceLogoUrl, "cdn.telescup.com.br");
  if (logo) result.serviceLogoUrl = logo;
  const checkout = safeUrl(row.checkoutUrl, "cashier.cupcode.com.br");
  if (checkout && /^\/pagar\/[a-zA-Z0-9_-]{16,200}$/u.test(new URL(checkout).pathname)) result.checkoutUrl = checkout;
  if (Array.isArray(row.includedItems)) result.includedItems = row.includedItems.filter((item) => typeof item === "string" && item.length <= 2000).slice(0, 100);
  if (Array.isArray(row.paymentHistory)) result.paymentHistory = row.paymentHistory.slice(0, 100).flatMap((item: unknown) => {
    if(typeof item !== "object" || item === null || Array.isArray(item)) return [];
    const event = item as Record<string, unknown>;
    if(typeof event.paidAt !== "string" || !Number.isFinite(Date.parse(event.paidAt)) || typeof event.amount !== "string"
      || !/^-?\d+(?:\.\d+)?$/u.test(event.amount) || typeof event.currency !== "string" || !/^[A-Z]{3}$/u.test(event.currency)) return [];
    return [{paidAt:event.paidAt, amount:event.amount, currency:event.currency,
      ...(["PIX", "CARD", "BOLETO"].includes(String(event.method)) ? {method:event.method} : {})}];
  });
  return result as CustomerInvoicePresentation;
};
